module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-white-359bf711.svg";